import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "@tanstack/react-router";
import { QueryClientProvider } from "@tanstack/react-query";

import { loadClientConfig } from "./lib/client-config";
import "./styles.css";

// Fetch the server's client config before importing anything that depends on it.
// auth.ts (pulled in transitively by ./router) touches MSAL at module load time,
// so these have to be dynamic imports — a static import above would be evaluated
// before this await ever runs and would race the fetch.
await loadClientConfig();
const [{ getRouter }, { initMsal }] = await Promise.all([import("./router"), import("./lib/msal")]);

const { router, queryClient } = getRouter();

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

// Await MSAL init BEFORE rendering so `handleRedirectPromise` finishes and
// route `beforeLoad` guards see the restored active account.
await initMsal();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);
